import axiosInstance from "./axiosInstance";

export const getLatestNews = async (locale = "en") => {
  const res = await axiosInstance.get(
    `/api/news-latests?locale=${locale}&sort=publishDate:desc`
  );

  return res.data.data.map((item) => ({
    id: item.id,
    title: item.title,
    slug: item.slug,
    date: item.publishDate,
    shortDesc: item.shortDesc,
  }));

};


export const getNewsBySlug = async (slug, locale = "en") => {
  const res = await axiosInstance.get(
    `/api/news-latests?filters[slug][$eq]=${slug}&locale=${locale}`
  );

  const item = res.data.data[0];

  if (!item) return null;

  return {
    id: item.id,
    title: item.title,
    slug: item.slug,
    date: item.publishDate,
    shortDesc: item.shortDesc,
    fullDesc: item.fullDesc,
  };
};

